import { createContext, useContext } from "react";

import { PPR_DOCUMENT_FLAG, type ShopperData } from "./shopper-data";

/**
 * What tells a render it belongs to a document shell (COM-482). Kept out of
 * `ppr-hole.tsx` so that file exports components only (fast refresh).
 */

/** Set by the server for a shell render (prerender or resume); null otherwise. */
export const ShopperDataContext = createContext<ShopperData | null>(null);

/** The client is hydrating a shell prelude (the prelude carries the flag). */
export const hydratingPprDocument =
  typeof window !== "undefined" &&
  (window as unknown as Record<string, unknown>)[PPR_DOCUMENT_FLAG] === true;

/**
 * Whether this render belongs to a shell document: the shell's prerender or
 * resume on the server, or the client hydrating a shell prelude. For the few
 * values that cannot live in a hole because their position in the head is
 * the contract (the COM-585 initial page context, ahead of GTM): such a
 * value renders a guest-invariant placeholder into the shell and resolves in
 * the browser. False for a regular document, which renders as before.
 */
export function useIsPprDocument(): boolean {
  return useContext(ShopperDataContext) !== null || hydratingPprDocument;
}
